import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { LayoutService } from './core/services/layout.service';
import { AlertsService } from './core/services/alerts.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  protected alertObservation = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    protected readonly layout: LayoutService,
    protected readonly alerts: AlertsService,
  ) {}

  ngOnInit(): void {
    this.alerts.activeAlert$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.alertObservation = '';
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected onObservationInput(event: Event) {
    const input = event.target as HTMLTextAreaElement;
    this.alertObservation = input.value;
  }

  protected closeAlertModal() {
    this.alerts.closeAlert();
    this.alertObservation = '';
  }

  protected resolveAlertModal() {
    const active = this.alerts.activeSnapshot;
    if (!active) return;
    const observation = this.alertObservation.trim();
    this.alertObservation = '';
    void this.alerts.resolveAlert(active._id, observation);
    this.alerts.closeAlert();
  }
}
